module.exports = __webpack_public_path__ + "img/Logo.57504eae.svg";